/**
 * The drawing context for a canvas that is drawn once and kept: a sprite,
 * a cached picture made from sprites, an item's picture in a bag square.
 *
 * Chrome (and Brave, and everything else built on it) draws a canvas on
 * the graphics card where it can, and a phone that puts a tab in the
 * background may take the graphics card's memory back from it. Every
 * canvas that lived there comes back empty, and nothing says so but a
 * contextlost event on each of them. The game's own canvas does not mind,
 * since it is painted again every frame; a sprite painted once at startup
 * is gone for good. That was the ground going black after a while in
 * another tab, with the creatures still drawn over it (2026-10-21, Matt's
 * screenshot: "When I leave the tab and come back later, I'm still
 * connected but the background disappears") — the creatures survived only
 * because inkTop reads their pixels back, which already moves a canvas
 * off the card for good. The bag's item pictures went with the ground.
 *
 * willReadFrequently asks for exactly that from the start: the canvas
 * lives in ordinary memory, where nothing takes it away, and the browser
 * copies it up to the card when it is drawn and keeps the copy while the
 * canvas is unchanged. A canvas painted fresh every time it is used (the
 * name layer, the light wash) does not need it and keeps the plain
 * context.
 *
 * It has to be the canvas's first getContext: the options of a later one
 * are ignored.
 */
export function keptContext(c: HTMLCanvasElement): CanvasRenderingContext2D {
  return c.getContext("2d", { willReadFrequently: true })!;
}
